import { render, staticRenderFns } from "./lever_noticeList.vue?vue&type=template&id=2a2eda52&scoped=true&"
import script from "./lever_noticeList.vue?vue&type=script&lang=js&"
export * from "./lever_noticeList.vue?vue&type=script&lang=js&"
import style0 from "./lever_noticeList.vue?vue&type=style&index=0&id=2a2eda52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2eda52",
  null
  
)

export default component.exports